



























import { Vue, Component, Prop } from 'vue-property-decorator';

import DateUtils from '@/utils/DateUtils';
import { getWordInitials } from '@/utils/getWordInitials';
import { treatValue } from '@/utils/moneyTreatments';
import AdminService from '@/api/AdminService';

import ResumeCard from '@/componentsV2/molecules/ResumeCard/ResumeCard.vue';
import CustomerDetail from '@/componentsV2/organisms/CustomerDetail/CustomerDetail.vue';
import AdminTabs from '@/componentsV2/molecules/AdminTabs/AdminTabs.vue';
import CustomerRecentActivity from '@/views/Admin/CustomersList/CustomerRecentActivity.vue';
import CustomerStoresVisited from '@/views/Admin/CustomersList/CustomerStoresVisited.vue';
import SubModalBase from '../SubModalBase/SubModalBase.vue';

type TData = {
  id: string;
  image: any;
  name: string;
  joined: string;
  lastSeen: string;
  spent: string;
  coins: string;
  lifetimeCoins: string;
};

@Component({
  components: {
    SubModalBase,
    ResumeCard,
    CustomerDetail,
    AdminTabs,
    CustomerRecentActivity,
    CustomerStoresVisited
  }
})
export default class AdminCustomerModal extends Vue {
  @Prop({ required: true }) data!: TData;

  adminService: AdminService = new AdminService();
  loadingCustomer: boolean = true;
  customerData: any = null;
  activeTabKey = 'recent-activity';

  get tabMapper() {
    return {
      'recent-activity': {
        label: 'Recent activity',
        component: 'CustomerRecentActivity',
        componentProps: {
          customerId: this.data.id
        }
      },
      'stores-visited': {
        label: 'Stores visited',
        component: 'CustomerStoresVisited',
        componentProps: {
          customerId: this.data.id
        }
      }
    };
  }

  get tabs() {
    return Object.entries(this.tabMapper).map(([key, value]) => ({
      key,
      label: value.label
    }));
  }

  get fallbackThumbPath() {
    const { name, lastname } = this.customer;

    return getWordInitials(`${name} ${lastname}`);
  }

  get thumbPath() {
    if (
      this.customerData &&
      this.customerData.image &&
      this.customerData.image.id
    ) {
      return JSON.parse(this.customerData.image.publicPath).small;
    }

    return '';
  }

  get customer() {
    return this.customerData.customer;
  }

  handleTabChanges(tabKey: string) {
    this.activeTabKey = tabKey;
  }

  async getCustomerById() {
    this.loadingCustomer = true;
    const response = await this.adminService.filterCustomerById(this.data.id);
    this.loadingCustomer = false;

    if (response.status !== 200) return;

    const [customerData] = response.data.items;

    const {
      name,
      lastname,
      createdAt,
      lastSeen,
      totalCoins,
      totalSpent,
      lifetimeCoins
    } = customerData.customer;

    this.customerData = {
      ...customerData,
      customer: Object.assign({}, customerData.customer, {
        joined: DateUtils.formatISOLongDate(createdAt, false, true),
        lastSeen: DateUtils.formatISOLongDate(lastSeen, false, true),
        coins: treatValue(totalCoins) || '0',
        spent: '$' + treatValue(totalSpent) || '0',
        lifetimeCoins: treatValue(lifetimeCoins) || '0',
        fullname: `${name} ${lastname}`
      })
    };
  }

  created() {
    this.getCustomerById();
  }
}
